// Donor Terms Modal Component
// Handles showing donor declaration terms modal when items are being listed to ED-iMART™

document.addEventListener('DOMContentLoaded', function() {
  const submitBtn = document.getElementById('bulkEditSubmitBtn');
  const form = document.querySelector('form:not(#skip-submit)');
  const modal = document.getElementById('donorDeclarationModal');
  const acceptCheckbox = document.getElementById('acceptDonorTerms');
  const acceptBtn = document.getElementById('acceptDonorTermsBtn');

  if (!submitBtn || !form || !modal) {
    console.warn('Required elements missing for donor terms modal');
    return;
  }

  // Check if any items have donate market type
  function hasDonateItems() {
    const saleTypeSelect = document.querySelector('select[name="item[sale_type]"]');
    console.log('saleTypeSelect:', saleTypeSelect ? saleTypeSelect.value : null);
    if (saleTypeSelect && saleTypeSelect.value === 'donate') {
      return true;
    }
    return false;
  }

  // Check if user has already accepted donor terms
  function userHasAcceptedTerms() {
    // This will be set by the server-side template
    console.log('userAcceptedDonorTerms:', window.userAcceptedDonorTerms);
    return window.userAcceptedDonorTerms || false;
  }

  // Handle form submission
  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Submit button clicked');
    const donateItems = hasDonateItems();
    const acceptedTerms = userHasAcceptedTerms();
    // Only show modal if items are being donated and user hasn't accepted terms
    if (donateItems && !acceptedTerms) {
      modal.style.display = 'flex';
    } else {
      form.submit();
    }
  });

  // Handle checkbox change
  if (acceptCheckbox) {
    acceptCheckbox.addEventListener('change', function() {
      if (acceptBtn) {
        acceptBtn.disabled = !this.checked;
      }
    });
  }

  // Handle accept button click
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function() {
      if (acceptCheckbox && acceptCheckbox.checked) {
        // Update user's accepted_terms status via AJAX
        fetch('/users/accept_donor_terms', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify({ accepted: true })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Donor terms accept response:', data);
          if (data.success) {
            modal.style.display = 'none';
            form.submit();
          } else {
            alert('Error accepting terms. Please try again.');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Error accepting terms. Please try again.');
        });
      }
    });
  }

  // Handle modal close
  modal.addEventListener('hidden.bs.modal', function() {
    // Reset checkbox and button state
    if (acceptCheckbox) {
      acceptCheckbox.checked = false;
    }
    if (acceptBtn) {
      acceptBtn.disabled = true;
    }
  });
});
